<div class="app-verify">
  <div class="app-verify__card">
    <img class="app-verify__logo" src="assets/images/rosie-icon-logo.svg" alt="Rosie" />
    <h1 class="app-verify__title">Verifying your email</h1>

    <ng-container *ngIf="code; else noCode">
      <p class="app-verify__text">
        We're opening the Rosie app to finish verifying your email. If it didn't open,
        tap the button below — or open the Rosie app and enter this code:
      </p>
      <div class="app-verify__code">{{ code }}</div>
      <button type="button" class="app-verify__btn" (click)="openApp()">Open Rosie app</button>
      <p class="app-verify__hint">
        Don't have the app yet?
        <a [href]="appStoreUrl" target="_blank" rel="noopener">App Store</a>
        ·
        <a [href]="playStoreUrl" target="_blank" rel="noopener">Google Play</a>
      </p>
    </ng-container>

    <ng-template #noCode>
      <p class="app-verify__text">
        This link is missing its verification code. Please open the most recent
        verification email and tap the button again.
      </p>
    </ng-template>
  </div>
</div>
